function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button")
  summary.setAttribute("aria-expanded", "false")

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id)
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
  })

  if (summary.closest("header-drawer")) return
  summary.parentElement.addEventListener("keyup", onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener("focusout", trapFocusHandlers.focusout)
  document.addEventListener("focusin", trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible")
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener("mousedown", (event) => {
    mouseClick = true
  })

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused")

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add("focused")
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*")
  })
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*")
  })
  document.querySelectorAll("video").forEach((video) => video.pause())
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin)
  document.removeEventListener("focusout", trapFocusHandlers.focusout)
  document.removeEventListener("keydown", trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return

  const openDetailsElement = event.target.closest("details[open]")
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector("summary")
  openDetailsElement.removeAttribute("open")
  summaryElement.setAttribute("aria-expanded", false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector("input")
    this.changeEvent = new Event("change", { bubbles: true })

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)))
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define("quantity-input", QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options["method"] || "post"
  var params = options["parameters"] || {}

  var form = document.createElement("form")
  form.setAttribute("method", method)
  form.setAttribute("action", path)

  for (var key in params) {
    var hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("name", key)
    hiddenField.setAttribute("value", params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid)

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default")
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default")
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute("data-provinces")
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none"
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option")
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ""
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option")
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector("details")

    if (navigator.platform === "iPhone") document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)

    this.addEventListener("keyup", this.onKeyUp.bind(this))
    this.addEventListener("focusout", this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)))
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)))
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return

    const openDetailsElement = event.target.closest("details[open]")
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute("open")
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"))
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening")
        summaryElement.setAttribute("aria-expanded", true)
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })
    summaryElement.setAttribute("aria-expanded", true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    /* this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);*/
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove("menu-opening")
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open")
      details.classList.remove("menu-opening")
    })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details")
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening")
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false)
    removeTrapFocus(detailsElement.querySelector("summary"))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute("open")
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define("menu-drawer", MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header")
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`)
    this.header.classList.add("menu-open")

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })

    summaryElement.setAttribute("aria-expanded", true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove("menu-open")
  }
}

customElements.define("header-drawer", HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this))
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide()
    })
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide()
      })
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector(".template-popup")
    document.body.classList.add("overflow-hidden")
    this.setAttribute("open", "")
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove("overflow-hidden")
    this.removeAttribute("open")
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define("modal-dialog", ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector("button")

    if (!button) return
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"))
      if (modal) modal.show(button)
    })
  }
}
customElements.define("modal-opener", ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener("click", this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div")
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true))

      this.setAttribute("loaded", true)
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"))
      if (focus) {
        try {
          deferredElement.focus({ preventScroll: true })
        } catch (e) {
          deferredElement.focus()
        }
      }

      /* AGNTC 2026-08-10 — Astrid: "there's no way to exit a video, and now
         I can't ... go to the other images."
         loadContent() appended the player and nothing ever took it away, so a
         video slide stayed a video for the rest of the session — the product
         photo behind it was unreachable. Worse, the Vimeo <iframe> swallows
         pointer events, so dragging the gallery died on that slide, and this
         gallery renders its arrows display:none — leaving the thumbnails as
         the only way out. Hence a real close control.
         Not added for model-viewer: 3D models are toggled, not exited. */
      if (deferredElement && deferredElement.tagName !== "MODEL-VIEWER") {
        this.appendChild(this.buildCloseButton())
      }
    }
  }

  buildCloseButton() {
    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "agntc-media-close"
    btn.setAttribute("aria-label", "Close video and return to the product images")
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      "</svg>"
    btn.addEventListener("click", (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.unloadContent()
    })
    return btn
  }

  /* Remove the player and put the slide back to its poster. loadContent()
     clones out of <template>, so the template is intact and play works again.
     Safe to call on an element that was never loaded. */
  unloadContent() {
    if (!this.getAttribute("loaded")) return

    /* Take focus OFF the player BEFORE removing it. loadContent() calls
       .focus() on the iframe, and removing a focused element hands focus to
       <body> — which makes the browser jump the page to the top. That was the
       "it auto scrolls after I click the X" report on 10 Aug (measured: y=300
       -> y=0). Returning focus to the play button is also the correct
       accessibility behaviour: focus goes back to the control that opened it.
       `loaded` is cleared first because the poster is display:none while it is
       set, and a hidden element cannot take focus. */
    this.removeAttribute("loaded")
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (poster) {
      try {
        poster.focus({ preventScroll: true })
      } catch (e) {
        /* older browsers: no options object */
      }
    }

    this.querySelectorAll(":scope > video, :scope > iframe, :scope > model-viewer, :scope > .agntc-media-close").forEach((el) => {
      if (el.tagName === "VIDEO") {
        try {
          el.pause()
        } catch (e) {}
      }
      el.remove()
    })
  }
}

customElements.define("deferred-media", DeferredMedia)

/* Unload every player inside `root` (default: the whole document). Called on
   gallery slide change so leaving a video restores its product photo. */
window.unloadAllMedia = function (root) {
  ;(root || document).querySelectorAll("deferred-media[loaded]").forEach((dm) => {
    if (typeof dm.unloadContent === "function") dm.unloadContent()
  })
}

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector(".slider-counter--current")
    this.pageTotalElement = this.querySelector(".slider-counter--total")
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.initPages()
    const resizeObserver = new ResizeObserver((entries) => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener("scroll", this.update.bind(this))
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this))
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0)
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    if (this.sliderItemsToShow.length === 0) return
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth)
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update() {
    const previousPage = this.currentPage
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      )
    }

    if (this.enableSliderLooping) return

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled")
    } else {
      this.prevButton.removeAttribute("disabled")
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled")
    } else {
      this.nextButton.removeAttribute("disabled")
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
  }

  onButtonClick(event) {
    event.preventDefault()
    const step = event.currentTarget.dataset.step || 1
    this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }
}

customElements.define("slider-component", SliderComponent)

class SlideshowComponent extends SliderComponent {
  constructor() {
    super()
    this.sliderControlWrapper = this.querySelector(".slider-buttons")
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"))
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)))
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this))
    this.setSlideVisibility()

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay()
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")
    this.autoplaySpeed = this.slider.dataset.speed * 1000

    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this))
    this.addEventListener("mouseover", this.focusInHandling.bind(this))
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this))
    this.addEventListener("focusin", this.focusInHandling.bind(this))
    this.addEventListener("focusout", this.focusOutHandling.bind(this))

    this.play()
    this.autoplayButtonIsSetToPlay = true
  }

  onButtonClick(event) {
    super.onButtonClick(event)
    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) return

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }

  update() {
    super.update()
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")
    this.prevButton.removeAttribute("disabled")

    if (!this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active")
      link.removeAttribute("aria-current")
    })
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active")
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true)
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
    this.play()
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play()
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause()
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off")
    clearInterval(this.autoplay)
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite")
    clearInterval(this.autoplay)
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused")
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused")
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow)
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a")
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex")
        item.setAttribute("aria-hidden", "false")
        item.removeAttribute("tabindex")
      } else {
        if (button) button.setAttribute("tabindex", "-1")
        item.setAttribute("aria-hidden", "true")
        item.setAttribute("tabindex", "-1")
      }
    })
  }

  linkToSlide(event) {
    event.preventDefault()
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define("slideshow-component", SlideshowComponent)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("change", this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, "", false)
    this.updatePickupAvailability()
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      //this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value)
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    //include Product Slider
    productSliderupdate(this.currentVariant.featured_media.id)

    /*const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);*/
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section},#product-form-fixed-${this.dataset.section}, #product-form-installment`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event("change", { bubbles: true }))
   
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability")
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute("available")
      pickUpAvailability.innerHTML = ""
    }
  }

  removeErrorMessage() {
    const section = this.closest("section")
    if (!section) return

    const productForm = section.querySelector("product-form")
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, "text/html")
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove("visibility-hidden")
        const f_destination = document.getElementById('sticky-order-panel-container')
        const f_source = html.getElementById('sticky-order-panel-container');
        
        if (f_source && f_destination) f_destination.innerHTML = f_source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"]')
    //inventory
    const inventoryNote = document.querySelector(".inventoryNote")
    const inventoryHtml = `${variantStock[this.currentVariant.id][0]}`

    if (!addButton) return

    if (disable) {
      addButton.setAttribute("disabled", "disabled")

      if (text) addButtonText.textContent = text
      //inventory
      inventoryNote.innerHTML = ""
      //show disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        if (item.checked === true) {
          item.classList.add("disabled")
        }
      })
      //document.querySelector('.quantity__input').removeAttribute('max')
    } else {
    
      addButton.removeAttribute("disabled")
      //remove disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        item.classList.remove("disabled")
      })
      addButtonText.textContent = window.variantStrings.addToCart
      document.querySelector(".ajax-add-notice").classList.add("hidden")
      //inventory
      if (variantStock[this.currentVariant.id][0] > 0 && variantStock[this.currentVariant.id][1] === "deny" && variantStock[this.currentVariant.id][2] === "shopify") {
        inventoryNote.textContent = inventoryHtml
        //document.querySelector('.quantity__input').setAttribute('max',inventoryHtml)
      }
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"]')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add("visibility-hidden")
    console.log("sdfdfr")
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define("variant-selects", VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"))
    this.options = fieldsets.map((fieldset) => {
      console.log(Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value)
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value
    })
  }
}
customElements.define("variant-radios", VariantRadios)

//Load Product Page and check current varian product image
function updateId() {
  //Radio
  if (document.querySelectorAll("variant-radios").length === 1) {
    document.querySelectorAll(".sr-only").forEach((variant) => {
      if (variant.checked) {
        //variant.parentNode.closest(".option-grid").previousElementSibling.lastChild.textContent = variant.value
      }
      variant.addEventListener("click", function () {
     //   this.parentNode.closest(".option-grid").previousElementSibling.lastChild.textContent = this.parentNode.dataset.name
      })
    })
  }
  //Select
  if (document.querySelectorAll("variant-selects").length === 1) {
    document.querySelectorAll(".option-variant").forEach((variant) => {
      if (variant.selected) {
        variant.parentNode.closest(".select").previousElementSibling.lastChild.previousSibling.textContent = variant.value
      }
    })
    document.querySelectorAll(".select__select").forEach((variant) => {
      variant.addEventListener("change", function () {
        variant.parentNode.closest(".select").previousElementSibling.lastChild.previousSibling.textContent = this.value
      })
    })
  }
  //Radio
  if (document.querySelectorAll("#radiojson").length === 1) {
    this.variantData = this.variantData || JSON.parse(document.querySelector("#radiojson").textContent)
    var varData = this.variantData || JSON.parse(document.querySelector("#radiojson").textContent)

    this.currentVariant = this.variantData.find((variant, index) => {
      if (variant.id == document.querySelector(".sr-only[data-id]").dataset.id && variant.featured_image != null) {
        productSliderupdate(variant.featured_media.id)
      }
    })
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false)
    if (!document.querySelector(".sr-only[data-id]").dataset.id && variable) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          productSliderupdate(variant.featured_media.id)
        }
      })
    }
    //Not avaliable radio
    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll(".sr-only").forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add("novaliable")
          }
        })
      }
    })
  }
  //Select
  if (document.querySelectorAll("#selectjson").length === 1) {
    this.variantData = this.variantData || JSON.parse(document.querySelector("#selectjson").textContent)

    this.currentVariant = this.variantData.find((variant, index) => {
      if (variant.id == document.querySelector(".option-variant[data-id]").dataset.id && variant.featured_image != null) {
        productSliderupdate(variant.featured_media.id)
      }
    })
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false)
    if (!document.querySelector(".option-variant[data-id]").dataset.id && variable) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          productSliderupdate(variant.featured_media.id)
        }
      })
    }

    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll(".option-variant").forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add("novaliable")
          }
        })
      }
    })
  }

  //Chek if is current variant avaliable
  if (document.querySelectorAll("input.sr-only").length > 0) {
    if (document.querySelector(".product-form__submit").disabled === true) {
      //show disable radio select
      document.querySelectorAll(".sr-only").forEach((item) => {
        if (item.checked === true) {
          item.classList.add("disabled")
        }
      }) 
    }
  }
}
updateId()

//Produc Slider Update
function productSliderupdate(variantImageId) {
  //Swatcher chnage slide
  if (document.querySelectorAll(".gallery-top .swiper-slide").length > 1) {
    const hittedIndex = document.querySelector('.imageslide-item[data-thumbid="' + variantImageId + '"]').dataset.index
    document.querySelectorAll(".gallery-top").forEach((item) => {
      let sliderImages = new Swiper(item, {
        direction: item.dataset.direction,
        spaceBetween: 0,
        allowTouchMove: false,
        /* AGNTC 2026-08-10: this re-init runs on VARIANT CHANGE and rebuilds the
           gallery Swiper from scratch, which dropped the unload-on-slide-change
           wired up in product.js. Without this, picking a different colour after
           watching a video brought the video trap back. */
        on: {
          slideChange: function () {
            if (typeof window.pauseAllMedia === "function") window.pauseAllMedia()
            if (typeof window.unloadAllMedia === "function") window.unloadAllMedia(this.el)
          },
        },
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        breakpoints: {
          0: {
            direction: "horizontal",
            allowTouchMove: true,
            spaceBetween: 0,
          },
          768: {
            direction: item.dataset.direction,
          },
        },
      })
      sliderImages.update()
      sliderImages.slideTo(hittedIndex, 0, false)
    })
  }
}

//Preview product card slider
function previewCardSlider() {
  if (document.querySelectorAll(".preview-card-slider").length > 0) {
    document.querySelectorAll(".preview-card-slider").forEach((item) => {
      const sliderProductCard = new Swiper(item, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-card-next",
          prevEl: ".swiper-card-prev",
        },
        pagination: {
          el: ".swiper-card-pagination",
          clickable: true,
        },
      })
    })
  }
}
previewCardSlider()

//siblings get
const getSiblings = function (elem) {
  // Setup siblings array and get the first sibling
  let siblings = []
  let sibling = elem.parentNode.firstChild
  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling)
    }
    sibling = sibling.nextSibling
  }
  return siblings
}

//Hover chnage image Card product preview
function chnageImageCardProdactPreview() {
  if (document.querySelectorAll(".preview-card").length > 0) {
    if (document.querySelector(".preview-card").dataset.hoverimagechnage != "false" || document.querySelector(".preview-card").dataset.hoverupdateslide != "false") {
      if (document.querySelectorAll(".preview-card .thumbnail-swatch").length > 0) {
        if (window.innerWidth > 990) {
          document.querySelectorAll(".card-color-swatch").forEach((item) => {
            item.addEventListener("mouseover", chnageMouseover)

            //mouseover
            function chnageMouseover(event) {
              //chnage image withous slider
              if (document.querySelector(".preview-card").dataset.hoverimagechnage != "false") {
                event.target.parentNode.parentNode.previousElementSibling.firstElementChild.style.backgroundImage = "url(" + event.target.dataset.image + ")"
              }

              //chnage image in slider
              if (document.querySelector(".preview-card").dataset.hoverupdateslide != "false" && document.querySelector(".preview-card-slider")) {
                Array.from(event.target.parentNode.parentNode.previousElementSibling.firstElementChild.firstElementChild.children).find((slide) => {
                  if (slide.dataset.id == event.target.dataset.mediaid) {
                    const speccliseUpdate = new Swiper(event.target.parentNode.parentNode.previousElementSibling.firstElementChild, {
                      navigation: {
                        nextEl: event.target.parentNode.parentNode.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.firstElementChild,
                        prevEl: event.target.parentNode.parentNode.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling,
                      },
                      pagination: {
                        el: event.target.parentNode.parentNode.previousElementSibling.firstElementChild.firstElementChild.nextElementSibling.lastElementChild,
                        clickable: true,
                      },
                    })
                    speccliseUpdate.slideTo(slide.dataset.index, 600, false)
                  }
                })
              }

              let getSiblingsitem = getSiblings(event.target)
              getSiblingsitem.forEach((siblings) => {
                //siblings item remove hovered
                siblings.classList.remove("hovered")
              })
              //add current item hovered class
              event.target.classList.add("hovered")
            } //end hover function
          }) //end foreach
        } //end check window width
      } //end check color swatcher has
    } //check hower effect torn on
  }
}
chnageImageCardProdactPreview()

//load fetch product card in popup
function clickPreviewProductPopupFetch(fetchUrl) {
  //create div container for ajax loaded product
  let html_div_popup = document.createElement("div")
  html_div_popup.classList.add("js-get-productdetail")

  html_div_popup.classList.add("loading")
  html_div_popup.innerHTML = `
    <svg aria-hidden="true" focusable="false" width="15" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
    `
  document.querySelector("body").append(html_div_popup)

  //fetch product page
  fetch(fetchUrl)
    .then((response) => response.text())
    .then((data) => {
      //create div container for ajax loaded product and find product detail info
      let html_div = document.createElement("div")
      html_div.innerHTML = data

      let html_dom = html_div.querySelector("#product-detail-info").innerHTML

      //remove loading class
      html_div_popup.classList.remove("loading")
      //add ready loaded content
      setTimeout(() => {
        html_div_popup.classList.add("loaded")
      }, 300)

      //create iiner div container for ajax loaded product
      let html_div_popup_inner = document.createElement("div")
      html_div_popup_inner.classList.add("js-get-productdetail_inner")
      html_div_popup_inner.innerHTML = html_dom

      if (html_div_popup_inner.querySelector("variant-radios")) {
        html_div_popup_inner.querySelector("variant-radios").setAttribute("data-update-url", "false")
      }
      html_div_popup_inner.querySelector(".product-imageslide").setAttribute("data-direction", "horizontal")
      html_div_popup_inner.querySelectorAll(".product-imageslide a").forEach((item) => {
        item.addEventListener("click", function (e) {
          e.preventDefault()
        })
        item.setAttribute("href", "#")
        item.classList.remove("zoom-gallery")
      })
      html_div_popup_inner.querySelector("h1").classList.remove("h2")
      html_div_popup_inner.querySelector("h1").classList.add("h3")
      // html_div_popup_inner.querySelector(".js-full-detail").classList.remove("hidden")
      //print ready elements
      html_div_popup.prepend(html_div_popup_inner)

      //create div close container for ajax loaded product
      let html_div_popup_close = document.createElement("div")
      html_div_popup_close.classList.add("js-get-productdetail-close")
      html_div_popup_close.innerHTML = `
            <span class="close-product-view">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </span>`
      html_div_popup_inner.prepend(html_div_popup_close)

      document.querySelector(".js-get-productdetail-close").addEventListener("click", function () {
        html_div_popup.classList.remove("loaded")
        setTimeout(() => {
          document.querySelector("body").classList.remove("overflow-hidden")
          document.querySelector(".js-get-productdetail").remove()
          if (document.querySelectorAll("pickup-availability-drawer").length > 0) {
            document.querySelector("pickup-availability-drawer").remove()
          }
        }, 300)
      })
      //create div overlay container for ajax loaded product
      let html_div_popup_overlay = document.createElement("div");
      html_div_popup_overlay.classList.add("js-get-productdetail-overlay")
      html_div_popup_inner.prepend(html_div_popup_overlay)
      document.querySelector(".js-get-productdetail-overlay").addEventListener("click", function () {
        html_div_popup.classList.remove("loaded")
        setTimeout(() => {
          document.querySelector("body").classList.remove("overflow-hidden")
          document.querySelector(".js-get-productdetail").remove()
          if (document.querySelectorAll("pickup-availability-drawer").length > 0) {
            document.querySelector("pickup-availability-drawer").remove()
          }
        }, 300)
      })

      const sliderThumbs = new Swiper(".js-get-productdetail_inner .product-thumbnail", {
        direction: "horizontal",
        slidesPerView: 4,
        spaceBetween: 10,
        freeMode: true,
        //noSwiping: false,
        breakpoints: {
          0: {
            direction: "horizontal",
          },
          769: {
            direction: "horizontal",
          },
        },
      })
      const sliderImages = new Swiper(".js-get-productdetail_inner .product-imageslide", {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        /* mousewheel OFF. Astrid, 10 Aug: "I also can[']t seem to fully scroll an
           image, it forces me down or up." Swiper's mousewheel module captures the
           wheel over the gallery and advances the SLIDE instead of letting the page
           scroll — on desktop this gallery is VERTICAL, so a normal downward scroll
           walked through 18-26 product images and the page never moved. It was only
           disabled at the 0-breakpoint, so phones were fine and desktop was not.
           Dragging, the thumbnails and the arrows all still change slides. */
        mousewheel: false,
        grabCursor: true,
        thumbs: {
          swiper: sliderThumbs,
        },
        navigation: {
          nextEl: ".js-get-productdetail_inner .swiper-button-next",
          prevEl: ".js-get-productdetail_inner .swiper-button-prev",
        },
        breakpoints: {
          0: {
            direction: "horizontal",
            mousewheel: false,
          },
        },
      })
      //upadate variant slider
      updateId()
      //update checkout button
      Shopify.PaymentButton.init()
      //add to cart update header counter
      // updateCartCounterHeader()
      //get new script links
      const pickupAvailabilityJs = html_div_popup_inner.querySelector(".pickup-availability-jsfile").getAttribute("src")
      console.log(html_div_popup_inner.querySelector(".product-form-jsfile"));
      const productFormjs = html_div_popup_inner.querySelector(".product-form-jsfile").getAttribute("src")
      //generate new script links
      const scriptPromise = new Promise((resolve, reject) => {
        const script1 = document.createElement("script")
        html_div_popup_inner.append(script1)
        script1.onload = resolve
        script1.onerror = reject
        script1.async = true
        script1.src = pickupAvailabilityJs
        //
        const script2 = document.createElement("script")
        html_div_popup_inner.append(script2)
        script2.onload = resolve
        script2.onerror = reject
        script2.async = true
        script2.src = productFormjs
        //
        const script3 = document.createElement("script")
        html_div_popup_inner.append(script3)
        script3.onload = resolve
        script3.onerror = reject
        script3.async = true
        script3.innerHTML = `${html_div_popup_inner.querySelector("#cariantproductjsopn").innerHTML}`
      })
    }) //end fetch then
}

//click by preview card link to show product
function clickPreviewProductPopup() {
  // if (document.querySelectorAll(".js-previe-product").length > 0) {
  if (document.querySelectorAll(".preview-card .card_product-add-to-cart .quick-view-btn").length > 0) {
    document.querySelectorAll(".preview-card .card_product-add-to-cart .quick-view-btn").forEach((item) => {
      item.addEventListener("click", function (link) {
        link.preventDefault()
        //load fetch product card in popup
        clickPreviewProductPopupFetch(this.getAttribute("href"))
      })
    })
  }
}
clickPreviewProductPopup()
